import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { User, UserSwitcherService } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * employee under his client account
 * includes control elements to end a session
 */
@Component({
  selector: 'app-impersonator',
  templateUrl: './impersonator.component.html',
  styleUrls: ['./impersonator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ImpersonatorComponent extends BaseComponent {
  private userSwitcherService = inject(UserSwitcherService);

  @Input() impersonated: User;

  reset(): void {
    this.userSwitcherService.reset();
  }
}
